import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from '../../../services/common.service';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-ist-registrations-view-modal',
  templateUrl: './ist-registrations-view-modal.component.html',
  styleUrls: ['./ist-registrations-view-modal.component.scss']
})
export class IstRegistrationsViewModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  optionsSelect = [
     { value: '0', label: 'Select' },
    { value: '1', label: 'Mr.' },
    { value: '2', label: 'Mrs.' },
    { value: '3', label: 'Dr.' },
    { value: '4', label: 'Rev.' },
    { value: '5', label: 'Ms.' },
  ];
  RegistrationForm: UntypedFormGroup;
  content: any;
  orgCode: string;
  orgId: string;
  userType: string;
  heading: string;
  action: Subject<any> = new Subject();
  headin: string;
  recState: boolean;
  prefix: any = [];

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public commonService: CommonService,
  ) {
  }

  ngOnInit() {
    this.orgCode = this.Content.content.ORGCODE;
    this.orgId = this.Content.content.ORGID;
    if (this.Content.content.USERTYPE !== undefined)
      this.userType = this.Content.content.USERTYPE;
    else
      this.userType = "I";
    const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';


    this.RegistrationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(''),
      PREFIX: new UntypedFormControl('', [Validators.required]),
      FIRST_NAME: new UntypedFormControl('', [Validators.required]),
      MIDDLE_NAME: new UntypedFormControl(''),
      LAST_NAME: new UntypedFormControl('', [Validators.required]),
      LICENSE_NO: new UntypedFormControl('', [Validators.required]),
      OCCUPATION: new UntypedFormControl('', [Validators.required]),
      SPECIALIZATION: new UntypedFormControl(''),
      ADDRESS: new UntypedFormControl('', [Validators.required]),
      POSTAL_CODE: new UntypedFormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]),
      CITY: new UntypedFormControl('', [Validators.required]),
      PROVINCE: new UntypedFormControl('', [Validators.required]),
      COUNTRY: new UntypedFormControl('', [Validators.required]),
      CONTACT_METHOD: new UntypedFormControl(''),
      PHONE: new UntypedFormControl('', [Validators.required, Validators.maxLength(20)]),
      PHONE_EXT: new UntypedFormControl('', [Validators.required, Validators.pattern("^[0-9]*$"),
      Validators.maxLength(5)]),
      OTHER_PHONE: new UntypedFormControl('', [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(15)]),
      OTHER_PHONE_EXT: new UntypedFormControl('', [Validators.pattern("^[0-9]*$"),

      Validators.maxLength(5)]),
      FAX: new UntypedFormControl(''),
      FAX_EXT: new UntypedFormControl('', [Validators.pattern("^[0-9]*$"),
      Validators.maxLength(5)]),
      EMAIL: new UntypedFormControl('', [Validators.required, Validators.email]),
      ConformEMAIL: new UntypedFormControl('', [Validators.required, Validators.email]),
      ORG_NAME: new UntypedFormControl('', [Validators.required]),
      ORG_WEB_SITE: new UntypedFormControl('', [Validators.required, Validators.pattern(reg)]),
      ORGTAX_NO: new UntypedFormControl('', [Validators.required]),
      ORG_ADDRESS: new UntypedFormControl('', [Validators.required]),
      ORG_POSTAL_CODE: new UntypedFormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]),
      ORG_CITY: new UntypedFormControl('', [Validators.required]),
      ORG_PROVINCE: new UntypedFormControl('', [Validators.required]),
      ORG_COUNTRY: new UntypedFormControl('', [Validators.required]),
      RECORD_STATE: new UntypedFormControl(true),
      STATUS: new UntypedFormControl(''),
      MODULE: new UntypedFormControl(''),
      ORGANIZATION_ID: new UntypedFormControl('', [Validators.required]),
      // USERCODE: new FormControl('', [Validators.required])
      //}, {
      //    validator: MustMatch('EMAIL', 'ConformEMAIL')
    });
    if ((this.Content.heading == "Edit")) {
    
      this.Content.heading = "Edit";
      this.getRegistedDetails(this.Content.content.Module);
    }

    if (this.Content.heading == "Create"){
       this.getPrefix(this.orgCode);
    }
    else
    {
      
      this.getPrefix(this.Content.content.orgID);
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
 
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getRegistedDetails(moduleType: string) {

    if (moduleType == "EAP") {
      this.summaryService.getEapScreenDataForEdit("api/ISTRegistration/EAPEdit?RecordID=" + this.Content.content.id).subscribe(result => {
        this.RegistrationForm.patchValue(result);
      });
    } else {
      this.summaryService.getScreenDataForEdit("api/ISTRegistration/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
        this.RegistrationForm.patchValue(result);
        this.orgId = this.RegistrationForm.controls["ORGANIZATION_ID"].value;
       this.RegistrationForm.controls['RECORD_STATE'].setValue(this.RegistrationForm.controls['RECORD_STATE'].value == 1? false: true);
      // this.getPrefix( this.orgId);
       // setTimeout(() => {
        //   this.RegistrationForm.disable({ emitEvent: false });
        // }, 100);
      });
    }

    this.RegistrationForm.controls['PREFIX'].disable();
    this.RegistrationForm.controls['FIRST_NAME'].disable();
    this.RegistrationForm.controls['MIDDLE_NAME'].disable();
    this.RegistrationForm.controls['LAST_NAME'].disable();
    this.RegistrationForm.controls['LICENSE_NO'].disable();
    this.RegistrationForm.controls['OCCUPATION'].disable();
    this.RegistrationForm.controls['SPECIALIZATION'].disable();
    this.RegistrationForm.controls['ADDRESS'].disable();
    this.RegistrationForm.controls['PHONE'].disable();
    this.RegistrationForm.controls['ORG_NAME'].disable();
    this.RegistrationForm.controls['ORG_WEB_SITE'].disable();
    this.RegistrationForm.controls['ORGTAX_NO'].disable();
    this.RegistrationForm.controls['ORG_ADDRESS'].disable();
    this.RegistrationForm.controls['ADDRESS'].disable();
    this.RegistrationForm.controls['EMAIL'].disable();
  }

  PostalCodekeyUP(value: string) {
    if (value.length == parseInt("5")) {
      this.commonService.getRegCity(value).subscribe(x => {
        if (x.Status) {
          this.RegistrationForm.controls["CITY"].setValue(x.Data.City);
          this.RegistrationForm.controls["PROVINCE"].setValue(x.Data.StateFullName);
          this.RegistrationForm.controls["COUNTRY"].setValue(x.Data.Country);
        }
      });
    }
    else {
      this.RegistrationForm.controls["CITY"].setValue("");
      this.RegistrationForm.controls["PROVINCE"].setValue("");
      this.RegistrationForm.controls["COUNTRY"].setValue("");
    }
  }

  OrgPostalCodekeyUP(value: string) {

    if (value.length == parseInt("5")) {
      this.commonService.getRegCity(value).subscribe(x => {
        if (x.Status) {
          this.RegistrationForm.controls["ORG_CITY"].setValue(x.Data.City);
          this.RegistrationForm.controls["ORG_PROVINCE"].setValue(x.Data.StateFullName);
          this.RegistrationForm.controls["ORG_COUNTRY"].setValue(x.Data.Country);
        }
      });
    }
    else {
      this.RegistrationForm.controls["ORG_CITY"].setValue("");
      this.RegistrationForm.controls["ORG_PROVINCE"].setValue("");
      this.RegistrationForm.controls["ORG_COUNTRY"].setValue("");
    }
  }

  Registration() {
    if (this.validateControls()) {
      var formData = this.RegistrationForm.value;
      formData["PHONE_EXT"] =0;// parseInt(formData["PHONE_EXT"]);
      formData["OTHER_PHONE_EXT"] =0;// parseInt(formData["OTHER_PHONE_EXT"]);
      formData["FAX_EXT"] =0;// parseInt(formData["FAX_EXT"]);
      formData["RECORD_STATE"] = 1;
      formData["CREATED_DATE"] = new Date();
      formData["LAST_UPDATED_DATE"] = new Date();
      formData["ORGCODE"] = this.orgCode.toLowerCase();
      formData["USERTYPE"] = this.userType;
      if (this.Content.content.RegistrationType == "EAP") {
        this.summaryService.Insert("api/appuser/inserteap", formData).subscribe(result => {
          if (result.Status == 0) {
            this.commonService.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/appuser/insertistregistration", formData).subscribe((result) => {
          if (result!=null && result.Status == 0) {
            this.commonService.SuccessBanner(result.Message);
            
            this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }

    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.RegistrationForm.value;

    if (formData.PREFIX === null || formData.PREFIX === "" || formData.PREFIX === undefined) {
      $("#PREFIX").addClass("ng-touched ng-invalid validate-error");
      $("#PREFIX").removeClass("ng-untouched ng-valid");
      message += "Please select Prefix <br/>";
      isValid = false;
    } else {
      $("#PREFIX").addClass("ng-untouched ng-valid");
      $("#PREFIX").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.FIRST_NAME === null || formData.FIRST_NAME === "" || formData.FIRST_NAME === undefined) {
      $("#FIRST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#FIRST_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter First Name <br/>";
      isValid = false;
    } else {
      $("#FIRST_NAME").addClass("ng-untouched ng-valid");
      $("#FIRST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.LAST_NAME === null || formData.LAST_NAME === "" || formData.LAST_NAME === undefined) {
      $("#LAST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#LAST_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Last Name <br/>";
      isValid = false;
    } else {
      $("#LAST_NAME").addClass("ng-untouched ng-valid");
      $("#LAST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message += "Please enter Email ID <br/>";
      isValid = false;
    } else {
      let isValidEmail = this.commonService.validateEmail(formData.EMAIL)
      if (isValidEmail) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += "Please enter valid Email ID <br/>";
        isValid = false;
      }
    }

    // if (formData.LICENSE_NO === null || formData.LICENSE_NO === "" || formData.LICENSE_NO === undefined) {
    //   $("#LICENSE_NO").addClass("ng-touched ng-invalid validate-error");
    //   $("#LICENSE_NO").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Medical License Number <br/>";
    //   isValid = false;
    // } else {
    //   $("#LICENSE_NO").addClass("ng-untouched ng-valid");
    //   $("#LICENSE_NO").removeClass("ng-touched ng-invalid validate-error");
    // }

    if (formData.OCCUPATION === null || formData.OCCUPATION === "" || formData.OCCUPATION === undefined) {
      $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
      $("#OCCUPATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Occupation <br/>";
      isValid = false;
    } else {
      $("#OCCUPATION").addClass("ng-untouched ng-valid");
      $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
    }

    // if (formData.ADDRESS.trim('\n') === null || formData.ADDRESS.trim('\n') === "" || formData.ADDRESS.trim('\n') === undefined) {
    //   $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
    //   $("#ADDRESS").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Address <br/>";
    //   isValid = false;
    // }
    // else if (formData.ADDRESS.length > 511) {
    //   $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
    //   $("#ADDRESS").removeClass("ng-untouched ng-valid");
    //   message += "Address Maximum 511 Exceeded <br/>";
    //   isValid = false;
    // }
    // else {
    //   $("#ADDRESS").addClass("ng-untouched ng-valid");
    //   $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
    // }

    // if (formData.PHONE === null || formData.PHONE === "" || formData.PHONE == undefined) {
    //   $("#PHONE").addClass("ng-touched ng-invalid validate-error");
    //   $("#PHONE").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Phone Number <br/>";
    //   isValid = false;
    // } 
    //else {
    //  // const phoneformat = /^[0-9]\d*$/;
      
    //   if (this.commonService.validatePhoneNo(formData.PHONE)) {
    //     $("#PHONE").addClass("ng-untouched ng-valid");
    //     $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#PHONE").addClass("ng-touched ng-invalid validate-error");
    //     $("#PHONE").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Valid Phone Number <br/>";
    //     isValid = false;
    //   }
    // }

    // if (formData.POSTAL_CODE === null || formData.POSTAL_CODE === "" || formData.POSTAL_CODE === undefined) {
    //   $("#POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
    //   $("#POSTAL_CODE").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Postal Code.<br/>";
    //   isValid = false;
    // } else {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.PHONE.match(phoneformat)) {
    //     $("#POSTAL_CODE").addClass("ng-untouched ng-valid");
    //     $("#POSTAL_CODE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
    //     $("#POSTAL_CODE").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Valid Postal Code.<br/>";
    //     isValid = false;
    //   }
    // }

    // if (formData.CITY === null || formData.CITY === "" || formData.CITY === undefined) {
    //   $("#CITY").addClass("ng-touched ng-invalid validate-error");
    //   $("#CITY").removeClass("ng-untouched ng-valid");
    //   message += "Please enter City.<br/>";
    //   isValid = false;
    // } else {
    //   $("#CITY").addClass("ng-untouched ng-valid");
    //   $("#CITY").removeClass("ng-touched ng-invalid validate-error");
    // }

    // if (formData.PROVINCE === null || formData.PROVINCE === "" || formData.PROVINCE === undefined) {
    //   $("#PROVINCE").addClass("ng-touched ng-invalid validate-error");
    //   $("#PROVINCE").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Province.<br/>";
    //   isValid = false;
    // } else {
    //   $("#PROVINCE").addClass("ng-untouched ng-valid");
    //   $("#PROVINCE").removeClass("ng-touched ng-invalid validate-error");
    // }



    // if (formData.COUNTRY === null || formData.COUNTRY === "" || formData.COUNTRY === undefined) {
    //   $("#COUNTRY").addClass("ng-touched ng-invalid validate-error");
    //   $("#COUNTRY").removeClass("ng-untouched ng-valid");
    //   message += "Please enter COUNTRY.<br/>";
    //   isValid = false;
    // } else {
    //   $("#COUNTRY").addClass("ng-untouched ng-valid");
    //   $("#COUNTRY").removeClass("ng-touched ng-invalid validate-error");
    // }

    // if (formData.PHONE_EXT === null || formData.PHONE_EXT === "") {
    //   $("#PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
    //   $("#PHONE_NO_EXT").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Phone Ext.<br/>";
    //   isValid = false;
    // } else {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.PHONE.match(phoneformat)) {
    //     $("#PHONE_NO_EXT").addClass("ng-untouched ng-valid");
    //     $("#PHONE_NO_EXT").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#PHONE_NO_EXT").addClass("ng-touched ng-invalid validate-error");
    //     $("#PHONE_NO_EXT").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Valid Phone Ext..<br/>";
    //     isValid = false;
    //   }
    // }


    // if (formData.OTHER_PHONE !== null && formData.OTHER_PHONE !== "") {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.OTHER_PHONE.match(phoneformat)) {
    //     $("#OTHER_PHONE").addClass("ng-untouched ng-valid");
    //     $("#OTHER_PHONE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#OTHER_PHONE").addClass("ng-untouched ng-valid");
    //     $("#OTHER_PHONE").removeClass("ng-touched ng-invalid validate-error");
    //     message += "Please enter valid alternate Phone Number.<br/>";
    //     isValid = false;
    //   }
    // }

    //if (formData.OTHER_PHONE_EXT === null || formData.OTHER_PHONE_EXT === "" && !isNaN(formData.OTHER_PHONE_EXT)) {
    //  $("#OTHER_PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
    //  $("#OTHER_PHONE_EXT").removeClass("ng-untouched ng-valid");
    //  message += "Please enter Phone Ext.<br/>";
    //  isValid = false;
    //} else {
    //  const phoneformat = /^[1-9]\d*$/;
    //  if (formData.PHONE.match(phoneformat)) {
    //    $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
    //    $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
    //  }
    //  else {
    //    $("#OTHER_PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
    //    $("#OTHER_PHONE_EXT").removeClass("ng-untouched ng-valid");
    //    message += "Please enter Valid Phone Ext..<br/>";
    //    isValid = false;
    //  }
    //}


    // if (formData.OTHER_PHONE_EXT !== null && formData.OTHER_PHONE_EXT !== "" && !isNaN(formData.OTHER_PHONE_EXT)) {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.OTHER_PHONE_EXT.match(phoneformat)) {
    //     $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
    //     $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
    //     $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
    //     message += "Please enter valid Other Phone Ext.<br/>";
    //     isValid = false;
    //   }
    // } 

    // if (formData.FAX !== null && formData.FAX !== "") {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.FAX.match(phoneformat)) {
    //     $("#FAX").addClass("ng-untouched ng-valid");
    //     $("#FAX").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#FAX").addClass("ng-untouched ng-valid");
    //     $("#FAX").removeClass("ng-touched ng-invalid validate-error");
    //     message += "Please enter valid alternate Fax.<br/>";
    //     isValid = false;
    //   }
    // }

    // if (formData.FAX_EXT !== null && formData.FAX_EXT !== "" && !isNaN(formData.FAX_EXT)) {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.FAX_EXT.match(phoneformat)) {
    //     $("#FAX_EXT").addClass("ng-untouched ng-valid");
    //     $("#FAX_EXT").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#FAX_EXT").addClass("ng-untouched ng-valid");
    //     $("#FAX_EXT").removeClass("ng-touched ng-invalid validate-error");
    //     message += "Please enter valid Fax Ext.<br/>";
    //     isValid = false;
    //   }
    // }

    

    // if (formData.EMAIL !== formData.ConformEMAIL) {
    //   $("#ConformEMAIL").addClass("ng-touched ng-invalid validate-error");
    //   $("#ConformEMAIL").removeClass("ng-untouched ng-valid");
    //   message += "E-Mail and Confirm E-Mail Must be same.<br/>";
    //   isValid = false;
    // }

    if (formData.ORG_NAME === null || formData.ORG_NAME === "") {
      $("#ORG_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#ORG_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Organization Name <br/>";
      isValid = false;
    } else {
      $("#ORG_NAME").addClass("ng-untouched ng-valid");
      $("#ORG_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.ORG_WEB_SITE === null || formData.ORG_WEB_SITE === "") {
      $("#ORG_WEB_SITE").addClass("ng-touched ng-invalid validate-error");
      $("#ORG_WEB_SITE").removeClass("ng-untouched ng-valid");
      message += "Please enter Website <br/>";
      isValid = false;
    } else {
      const siteformat = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      if (formData.ORG_WEB_SITE.match(siteformat)) {
        $("#ORG_WEB_SITE").addClass("ng-untouched ng-valid");
        $("#ORG_WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#ORG_WEB_SITE").addClass("ng-touched ng-invalid validate-error");
        $("#ORG_WEB_SITE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Website <br/>";
        isValid = false;
      }
    }

    // if (formData.ORGTAX_NO === null || formData.ORGTAX_NO === "") {
    //   $("#ORGTAX_NO").addClass("ng-touched ng-invalid validate-error");
    //   $("#ORGTAX_NO").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Institution Tax Number <br/>";
    //   isValid = false;
    // } else {
    //   $("#ORGTAX_NO").addClass("ng-untouched ng-valid");
    //   $("#ORGTAX_NO").removeClass("ng-touched ng-invalid validate-error");
    // }


    if (formData.ORG_ADDRESS.trim('\n') === null || formData.ORG_ADDRESS.trim('\n') === "" || formData.ORG_ADDRESS.trim('\n') === undefined) {
      $("#ORG_ADDRESS").addClass("ng-touched ng-invalid validate-error");
      $("#ORG_ADDRESS").removeClass("ng-untouched ng-valid");
      message += "Please enter Address<br/>";
      isValid = false;
    } else {
      $("#ORG_ADDRESS").addClass("ng-untouched ng-valid");
      $("#ORG_ADDRESS").removeClass("ng-touched ng-invalid validate-error");
    }

    // if (formData.ORG_POSTAL_CODE === null || formData.ORG_POSTAL_CODE === "" || formData.ORG_POSTAL_CODE === undefined) {
    //   $("#ORG_POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
    //   $("#ORG_POSTAL_CODE").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Org. Postal Code.<br/>";
    //   isValid = false;
    // } else {
    //   const phoneformat = /^[1-9]\d*$/;
    //   if (formData.PHONE.match(phoneformat)) {
    //     $("#ORG_POSTAL_CODE").addClass("ng-untouched ng-valid");
    //     $("#ORG_POSTAL_CODE").removeClass("ng-touched ng-invalid validate-error");
    //   }
    //   else {
    //     $("#ORG_POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
    //     $("#ORG_POSTAL_CODE").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Valid Org. Postal Code.<br/>";
    //     isValid = false;
    //   }
    // }

    //   if (formData.ORG_CITY === null || formData.ORG_CITY === "") {
    //     $("#ORG_CITY").addClass("ng-touched ng-invalid validate-error");
    //     $("#ORG_CITY").removeClass("ng-untouched ng-valid");
    //     message += "Please enter Org. City.<br/>";
    //     isValid = false;
    //   } else {
    //     $("#ORG_CITY").addClass("ng-untouched ng-valid");
    //     $("#ORG_CITY").removeClass("ng-touched ng-invalid validate-error");
    //   }

    // if (formData.ORG_PROVINCE === null || formData.ORG_PROVINCE === "") {
    //   $("#ORG_PROVINCE").addClass("ng-touched ng-invalid validate-error");
    //   $("#ORG_PROVINCE").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Org. State/Province.<br/>";
    //   isValid = false;
    // } else {
    //   $("#ORG_PROVINCE").addClass("ng-untouched ng-valid");
    //   $("#ORG_PROVINCE").removeClass("ng-touched ng-invalid validate-error");
    // }

    // if (formData.ORG_COUNTRY === null || formData.ORG_COUNTRY === "") {
    //   $("#ORG_COUNTRY").addClass("ng-touched ng-invalid validate-error");
    //   $("#ORG_COUNTRY").removeClass("ng-untouched ng-valid");
    //   message += "Please enter Org. Country.<br/>";
    //   isValid = false;
    // } else {
    //   $("#ORG_COUNTRY").addClass("ng-untouched ng-valid");
    //   $("#ORG_COUNTRY").removeClass("ng-touched ng-invalid validate-error");
    // }

    if (!isValid)
    this.commonService.ValidationBanner(message);
    return isValid;
  }

  BlockUser() {
    var formData = this.RegistrationForm.value;
    formData.ID = this.Content.content.id;
    formData.RECORD_STATE = this.RegistrationForm.controls["RECORD_STATE"].value == true ? 0 : 1;
    formData.MODULE = "IST";
    this.summaryService.updateUser("api/ISTRegistration/updateUser", formData).subscribe((result: any) => {
      if ((result.Status == 0)) {
        // this.commonService.ErrorBanner("update successful");
        this.commonService.SuccessBanner("Registration Details updated successfully");
      //  this.action.next("Yes");
        this.modalRef.close("Yes");
      } else {
        this.commonService.ValidationBanner(result.Message);
      }


    });
  }

  getPrefix(orgId: any){
    this.summaryService.getPrefix(orgId).subscribe((result) => {
      if(result != null){
        this.prefix = result;  
        this.prefix=  [{label:"Select",value:"", checked: true}].concat(this.prefix);
      }
    });
  }
}
